<section class="ac-flex-col ac-gap-xl">
  <div class="header ac-flex ac-sp-btw">
    @if (title(); as t) {
      <div class="ac-flex ac-algn-ctr ac-gap-sm">
        @if (iconUrl(); as url) {
          <ac-icon [iconUrl]="url" [size]="24" />
        }
        <div [class]="titleClass()">
          {{ t }}
        </div>
      </div>
    }

    <div class="nav-btns" [class]="{ hidden: hideNavButtons() }">
      @if (viewAllLink(); as link) {
        @if (device.isXsScreen()) {
          <a class="ac-label ac-flex ac-algn-ctr ac-gap-sm"
            [routerLink]="link">
            <span class="ac-label ac-title-sm"> View All </span>
            <ac-icon iconKey="hr:arrow_right_circle" [size]="16" />
          </a>
        } @else {
          <button
            mat-button
            class="carousel-btn view-all-btn"
            type="button"
            [routerLink]="link">
            View&nbsp;All
          </button>
        }
      }

      <button
        #leftButton
        mat-button
        class="carousel-btn left-btn"
        type="button"
        [class]="{ hidden: device.isXsScreen() }"
        (click)="scrollLeft()">
        <ac-icon iconKey="hr:arrow_left" [size]="18" />
      </button>

      <button
        #rightButton
        mat-button
        class="carousel-btn right-btn"
        type="button"
        [class]="{ hidden: device.isXsScreen() }"
        (click)="scrollRight()">
        <ac-icon iconKey="hr:arrow_right" [size]="18" />
      </button>
    </div>
  </div>

  <div class="carousel-wrapper">
    <div
      class="edge-blur edge-blur--left"
      [class.edge-blur--visible]="canScrollPrev()">
    </div>
    <div #carouselViewport class="carousel-viewport">
      <div class="carousel-container">
        <ng-content select="app-slide"></ng-content>
      </div>
    </div>
    <div
      class="edge-blur edge-blur--right"
      [class.edge-blur--visible]="canScrollNext()">
    </div>
  </div>
</section>
